import * as graphqlConfig from './graphql.config'
import * as mainConfig from './main.config'
import * as walletConfig from './wallet.config'

export { graphqlConfig, mainConfig, walletConfig }
